import data from './data';
import single from './single';

export default {
  data,
  single,
};
